<template>
  <div class="content-body">
    <!-- row -->
    <div class="container-fluid">
      <div class="page-titles form-head d-flex flex-wrap justify-content-between align-items-center mb-4">
        <h2 class="text-black font-w600 mb-0 mr-auto mb-2 pr-3">Request Money</h2>
        <a v-if="tabToShow == 1" href="javascript:void(0)" class="btn btn-primary btn-rounded mr-3  mb-2" @click="$router.push({name: 'request-money-initiate'})" >
          <i class="las la-file scale5 mr-3"></i>
          Add Request</a>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Request Money</h4>
            </div>
            <div class="card-body">
              <!-- Nav tabs -->
              <div class="default-tab">
                <ul class="nav nav-tabs" role="tablist">
                  <li class="nav-item" @click="tabToShow = 1">
                    <a class="nav-link" :class="tabToShow == 1 ? 'active' : ''" data-toggle="tab" href="#home"><i
                        class="las la-filter"></i> My Requests</a>
                  </li>
                  <li class="nav-item" @click="tabToShow = 2">
                    <a class="nav-link" :class="tabToShow == 2 ? 'active' : ''" data-toggle="tab" href="#profile"><i
                        class="las la-poll-h"></i> User Requests</a>
                  </li>
                </ul>
                <div class="tab-content">
                  <div class="tab-pane fade show " :class="tabToShow == 1 ? 'active' : ''" id="home" role="tabpanel">
                    <div class="pt-4">
                      <div class="table-responsive table-hover fs-14 card-table">
                        <CommonTable
                            url="v1/get-money-requests"
                            :tableHeaderValues="tableHeaderValues"
                            :actions="actions"
                            :mutedData="mutedData"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane fade show" :class="tabToShow == 2 ? 'active' : ''" id="profile">
                    <div class="pt-4">
                      <div v-if="tab2sendCall"
                           class="table-responsive table-hover fs-14 card-table">
                        <CommonTable
                            url="v1/get-user-request-money"
                            :tableHeaderValues="userRequestHeaderValues"
                            :actions="userRequestActions"
                            :mutedData="mutedData"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  mounted() {
    setTimeout(() => {
      this.tab2sendCall = true;
    }, 2000)
  },
  data(){
    return{
      tabToShow: 1,
      tab2sendCall: false,
      tableHeaderValues: [
        {
          title: 'Email',
          valueKey: 'email'
        },
        {
          title: 'Phone',
          valueKey: 'phone_number',
        },
        {
          title: 'Amount',
          valueKey: 'amount',
          html: true,
          alter: function(value) {
            var html=''
            html = `<span class="text-black fs-20 font-w600">${value/100}</span>`

            return html

          }
        },
        {
          title: 'Currency',
          valueKey: 'user_account.currency.code',
          html: true,
          alter: function (value){
            var html=''
            html = ` <a href="javascript:void()" class="badge badge-circle badge-success">${value}</a>`

            return html



          }
        },
        {
          title: 'Status',
          valueKey: 'statusStr',
          html: true,
          alter: function (value) {
            var html = ''
            if (value == 'PENDING') {
              html = `		<span class="badge light badge-warning">
														<i class="fa fa-circle text-warning mr-1"></i>
														${value}
													</span>`
            } else if(value == 'CANCELED') {
              html = `		<span class="badge light badge-danger">
														<i class="fa fa-circle text-danger mr-1"></i>
														${value}
													</span>`
            }else {
              html = `		<span class="badge light badge-success">
														<i class="fa fa-circle text-success mr-1"></i>
														${value}
													</span>`
            }

            return html

          }
        },
        {
          title: 'Transaction Time/Date',
          valueKey: 'created_at',
          alter: function(value) {
            return new Date(value).toISOString().slice(0, 16).replace('T',' ')
          }
        },
      ],
      userRequestHeaderValues: [
        {
          title: 'Email',
          valueKey: 'user_account.user.email',
        },
        {
          title: 'Notes',
          valueKey: 'notes',
        },
        {
          title: 'Amount',
          valueKey: 'amount',
          html: true,
          alter: function(value) {
            var html=''
            html = `<span class="text-black fs-20 font-w600">${value/100}</span>`

            return html

          }
        },
        {
          title: 'Currency',
          valueKey: 'user_account.currency.code',
          html: true,
          alter: function (value){
            var html=''
            html = ` <a href="javascript:void()" class="badge badge-circle badge-success">${value}</a>`

            return html



          }
        },
        {
          title: 'Status',
          valueKey: 'statusStr',
          html: true,
          alter: function (value) {
            var html = ''
            if (value == 'PENDING') {
              html = `		<span class="badge light badge-warning">
														<i class="fa fa-circle text-warning mr-1"></i>
														${value}
													</span>`
            } else if(value == 'CANCELED' || value == 'REJECTED') {
              html = `		<span class="badge light badge-danger">
														<i class="fa fa-circle text-danger mr-1"></i>
														${value}
													</span>`
            }else {
              html = `		<span class="badge light badge-success">
														<i class="fa fa-circle text-success mr-1"></i>
														${value}
													</span>`
            }

            return html

          }
        },
        {
          title: 'Transaction Time/Date',
          valueKey: 'created_at',
          alter: function(value) {
            return new Date(value).toISOString().slice(0, 16).replace('T',' ')
          }
        },
      ],
      userRequestActions: [
        {
          title: 'Accept',
          conditionalRendering: true,
          condition: (row)=>{
            if(row.statusStr == "CANCELED" || row.statusStr == "ACCEPTED" || row.statusStr == "REJECTED"){
              return false
            }
            return true
          },
          cta: (row) => {
            this.$store.commit("setUserRequestSendMoneyData", row)
            this.$router.push({name: 'user-request-send-money-initiate'})
          }
        },
        {
          title: 'Reject',
          conditionalRendering: true,
          condition: (row)=>{
            if(row.statusStr == "CANCELED" || row.statusStr == "ACCEPTED" || row.statusStr == "REJECTED"){
              return false
            }
            return true
          },
          cta: (row, index) => {
            this.cancelOrRejectRequest(row, index,'v1/reject-request-money', 'REJECTED')
          },
          class: 'ml-2 btn-danger'
        },
      ],
      actions: [
        {
          title: 'Cancel Request',
          conditionalRendering: true,
          condition: (row)=>{
            if(row.statusStr == "CANCELED"){
              return false
            }
            return true
          },
          cta: (row, index) => {
            this.cancelOrRejectRequest(row, index,'v1/cancel-request-money')
          }
        },
      ],
      mutedData: [],
    }
  },
  methods:{
    acceptUserRequest(row, index) {
      this.makeRequest('post', 'v1/cancel-request-money', {requestId:row.id}).then(callResponse => {

        this.loader = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.mutedData = {
              index: index,
              statusStr : 'CANCELED'
            }
          }
          else if (code == 401) {
            this.$router.push({name: 'send-otp'});
          }
        }

      });

    },
    cancelOrRejectRequest(row, index,endpoint,status = 'CANCELED') {
      this.makeRequest('post', endpoint, {requestId:row.id}).then(callResponse => {

        this.loader = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.mutedData = {
              index: index,
              statusStr : status
            }
          }
          else if (code == 401) {
            this.$router.push({name: 'send-otp'});
          }
        }

      });

    },
  },
  watch: {
    tabToShow() {

    }
  }
}
</script>

